module.exports = "/dist/b78bb9f8ecec6c5a924c873f1818095f.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-900italic.woff
// module id = 142
// module chunks = 0